export const environment = {
  production: true,
  ssoUrl: 'https://auth.fenix.portacapena.com',
  localUrl: 'https://customer.fenix.portacapena.com',
  apiUrl: 'https://api.fenix.portacapena.com/customer-portal/',
};
